<template>
    <nav class="fixed top-0 left-0 right-0 bg-white dark:bg-gray-900 shadow-md z-10">
      <div class="flex justify-center p-4 max-w-4xl mx-auto">
        <ul class="flex justify-around w-full">
          <li
            v-for="(step, index) in steps"
            :key="step.id"
            class="flex items-center"
            :class="{
              'text-custom-yellow': index <= currentStepIndex,
              'dark:text-custom-yellow': index <= currentStepIndex,
              'text-gray-500': index > currentStepIndex,
              'dark:text-gray-300': index > currentStepIndex
            }"
          >
            <!-- Step Indicator (Number) -->
            <a
              href="#"
              class="flex items-center justify-center w-10 h-10 rounded-full text-black font-bold transition-all duration-200"
              :class="{
                'bg-custom-yellow': index <= currentStepIndex,
                'bg-gray-100': index > currentStepIndex,
                'dark:bg-custom-yellow': index <= currentStepIndex,
                'dark:bg-gray-300': index > currentStepIndex
              }"
            >
              {{ index + 1 }}
            </a>
  
            <!-- Optional step label -->
            <span v-if="index < steps.length - 1" class="mx-2 font-semibold">
              {{ step.label }}
            </span>
          </li>
        </ul>
      </div>
    </nav>
  </template>
  
  <script>
  export default {
    name: 'NavBar',
    props: {
      steps: {
        type: Array,
        required: true
      },
      currentStep: {
        type: String,
        required: true
      }
    },
    computed: {
      currentStepIndex() {
        return this.steps.findIndex(step => step.id === this.currentStep);
      }
    }
  }
  </script>
  
  <style scoped>
  /* Additional custom styles can go here */
  </style>
  